import { Box, Flex } from "@chakra-ui/react";
import Footer from "../components/HeaderFooter/Footer";
import Header from "../components/HeaderFooter/Header";
import FeedbackSection from "../components/Common/FeedbackSection";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Layout = ({ children }) => {
  const location = useLocation();

  // Check if current page is home page for global background
  const isHomePage = location.pathname === "/";

  const isCareersPage =
    location.pathname === "/careers" ||
    location.pathname === "/join-us" ||
    location.pathname === "/team-activity" ||
    location.pathname === "/job-opening" ||
    location.pathname.startsWith("/job-details") ||
    location.pathname.startsWith("/internship") ||
    location.pathname.startsWith("/skill-development") ||
    location.pathname.startsWith("/course-details") ||
    location.pathname.startsWith("/team-activity");

  const isLoginRegisterPage = location.pathname === "/login-register";

  // Framer motion animation variants
  const variants = {
    initial: { opacity: 0, y: 0 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 0 },
  };

  const transition = {
    duration: 0.4,
    ease: "easeInOut",
  };

  return (
    <Flex 
      direction="column" 
      minH="100vh"
      sx={isHomePage ? {
        backgroundImage: "url('/png/background.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      } : {}}
    >
      {!isLoginRegisterPage && <Header />}

      <AnimatePresence mode="wait">
        <Box
          as={motion.main}
          key={location.pathname}
          variants={variants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={transition}
          flex="1"
        >
          {children}
        </Box>
      </AnimatePresence>

      {!isCareersPage && !isLoginRegisterPage && (
        <>
          <FeedbackSection />
          <Footer />
        </>
      )}
    </Flex>
  );
};

export default Layout;
